// Count container size
export const isLarge = (value) => {
    return value >= 40;
};
export const isMedium = (value) => {
    return value < 40 && value >= 20;
};
export const isSmall = (value) => {
    return value < 20;
};
